/* eslint-disable no-unused-vars */
import Swal from "sweetalert2";
export default {
  namespaced: true,
  state: {
    codes: {
      loading: false,
      data: [],
      pagination: {
        current: null,
        total: null,
        data: [],
      },
    },
    OCF21B: {
      loading: false,
      data: [],
    },
    OCF21BSentInvoices: {
      loading: false,
      data: [],
    },
    approvedInvoicesLoading: false,
    documents: {
      loading: false,
      data: [],
      pagination: {
        current: null,
        total: null,
        data: [],
      },
    },
  },
  mutations: {
    SET_CODES: (state, data) => {
      state.codes.data = data;
    },
    SET_CODES_LOADING: (state, data) => {
      state.codes.loading = data;
    },
    SET_CODES_PAGINATION: (state, data) => {
      state.codes.pagination = data;
    },
    SET_OCF21B_DATA: (state, data) => {
      state.OCF21B.data = data;
    },
    SET_OCF21B_LOADING: (state, data) => {
      state.OCF21B.loading = data;
    },
    SET_OCF21B_SENT_INVOICES_DATA: (state, data) => {
      state.OCF21BSentInvoices.data = data;
    },
    SET_OCF21B_SENT_INVOICES_LOADING: (state, data) => {
      state.OCF21BSentInvoices.loading = data;
    },
    SET_APPROVED_INVOICES_LOADING: (state, data) => {
      state.approvedInvoicesLoading = data;
    },
    SET_DOCUMENTS: (state, data) => {
      state.documents.data = data;
    },
    SET_DOCUMENTS_LOADING: (state, data) => {
      state.documents.loading = data;
    },
    SET_DOCUMENTS_PAGINATION: (state, data) => {
      state.documents.pagination = data;
    },
  },
  actions: {
    getOCF21BInvoices: function ({ commit }) {
      commit("SET_OCF21B_LOADING", true);
      const vm = this;
      return new Promise((resolve) => {
        return vm.$http.get(`hcai/ocf21b`).then(
          (res) => {
            if (res.status == 200) {
              commit("SET_OCF21B_DATA", res.data.data);
            }
            commit("SET_OCF21B_LOADING", false);
            resolve(res.data.data);
          },
          (err) => {
            commit("SET_OCF21B_LOADING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  ((err || {}).data || {}).message || "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
    getOCF21BSentInvoices: function ({ commit }) {
      commit("SET_OCF21B_SENT_INVOICES_LOADING", true);
      const vm = this;
      return new Promise((resolve) => {
        return vm.$http
          .get(`hcai/ocf21b-sent-invoices`)
          .then((res) => {
            if (res.status == 200) {
              commit("SET_OCF21B_SENT_INVOICES_DATA", res.data.data);
            }
            commit("SET_OCF21B_SENT_INVOICES_LOADING", false);
            resolve(res.data.data);
          })
          .catch((err) => {
            commit("SET_OCF21B_SENT_INVOICES_LOADING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  ((err || {}).data || {}).message || "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          });
      });
    },
    approveOCF21BInvoices: function ({ commit }, payload) {
      commit("SET_APPROVE_INVOICES_LOADING", true);
      const vm = this;
      return new Promise((resolve) => {
        return vm.$http
          .post(`hcai/approve-ocf21b-invoice`, payload)
          .then((res) => {
            if (res.status == 200) {
              Swal.fire({
                title: "Approved successfully",
                text: "Selected clients approved successfully",
                icon: "success",
              });
            }
            commit("SET_APPROVE_INVOICES_LOADING", false);
            resolve(true);
          })
          .catch((err) => {
            commit("SET_APPROVE_INVOICES_LOADING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  ((err || {}).data || {}).message || "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          });
      });
    },
    approveAllOCF21B: function ({ state, commit }, status) {
      const newOCF21B = state.OCF21B.data.map((invoice) => {
        invoice.approved = status;
        return invoice;
      });
      commit("SET_OCF21B_DATA", newOCF21B);
    },
    getCodes: function ({ commit, state }, payload) {
      const vm = this;
      let url = `hcai-codes`;
      if (payload) {
        if (payload.limit) {
          url = `${url}?limit=${payload.limit}`;
        }
        if (payload.page) {
          url = `${url}&page=${payload.page}`;
        }
        if (payload.code) {
          url = `${url}${payload.limit ? "&" : "?"}code=${payload.code}`;
        }
        if (payload.description) {
          url = `${url}${
            payload.limit || payload.code ? "&" : "?"
          }description=${payload.description}`;
        }
      }

      if (!payload || !payload.page) {
        commit("SET_CODES_LOADING", true);
      }
      return new Promise((resolve) => {
        return vm.$http.get(url).then(
          (res) => {
            commit("SET_CODES_LOADING", false);
            if (res.status == 200) {
              if (payload && payload.page) {
                commit("SET_CODES_PAGINATION", {
                  total: res.data.meta.total,
                  current: res.data.meta.current_page,
                  data: [...state.codes.pagination.data, ...res.data.data],
                });
              } else if (payload && payload.limit) {
                commit("SET_CODES_PAGINATION", {
                  total: res.data.meta.total,
                  current: res.data.meta.current_page,
                  data: res.data.data,
                });
              } else {
                commit("SET_CODES", res.data.data);
              }
              resolve(res.data.data);
            }
          },
          (err) => {
            commit("SET_CODES_LOADING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  ((err || {}).data || {}).message || "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
    // uploadCodes: function ({ commit }, payload) {
    //   commit("SET_CODES_LOADING", true);
    //   const vm = this;
    //   return new Promise((resolve) => {
    //     return vm.$http
    //       .post(`hcai/upload-codes`, payload)
    //       .then((res) => {
    //         if (res.status == 200) {
    //           Swal.fire({
    //             title: "Uploaded successfully",
    //             text: "Codes uploaded successfully",
    //             icon: "success",
    //           });
    //         }
    //         commit("SET_CODES_LOADING", false);
    //         resolve(true);
    //       })
    //       .catch((err) => {
    //         commit("SET_CODES_LOADING", false);
    //         if (!err.accessDenied) {
    //           Swal.fire({
    //             title: "Error",
    //             text:
    //               ((err || {}).data || {}).message || "Something went wrong...",
    //             icon: "error",
    //           });
    //         }
    //         resolve(false);
    //       });
    //   });
    // },
    getDocuments: function ({ commit, state }, payload) {
      const vm = this;
      let url = `hcai-documents`;
      if (payload) {
        if (payload.limit) {
          url = `${url}?limit=${payload.limit}`;
        }
        if (payload.page) {
          url = `${url}&page=${payload.page}`;
        }
        if (payload.type) {
          url = `${url}&type=${payload.type}`;
        }
        if (payload.status) {
          url = `${url}&status=${payload.status}`;
        }
        if (payload.patientId) {
          url = `${url}&patient_id=${payload.patientId}`;
        }
      }

      if (!payload || !payload.page) {
        commit("SET_DOCUMENTS_LOADING", true);
      }
      return new Promise((resolve) => {
        return vm.$http.get(url).then(
          (res) => {
            commit("SET_DOCUMENTS_LOADING", false);
            if (res.status == 200) {
              if (payload && payload.page) {
                commit("SET_DOCUMENTS_PAGINATION", {
                  total: res.data.meta.total,
                  current: res.data.meta.current_page,
                  data: [...state.documents.pagination.data, ...res.data.data],
                });
              } else if (payload && payload.limit) {
                commit("SET_DOCUMENTS_PAGINATION", {
                  total: res.data.meta.total,
                  current: res.data.meta.current_page,
                  data: res.data.data,
                });
              } else {
                commit("SET_DOCUMENTS", res.data.data);
              }
              resolve(res.data.data);
            }
          },
          (err) => {
            commit("SET_DOCUMENTS_LOADING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  ((err || {}).data || {}).message || "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
    getBillingItemsForDocument: function (_, id) {
      const vm = this;
      return new Promise((resolve) => {
        return vm.$http.get(`hcai-documents/${id}/line-items`).then(
          (res) => {
            if (res.status == 200) {
              return resolve(res.data.data);
            }
            resolve(false);
          },
          (err) => {
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  ((err || {}).data || {}).message || "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
  },
};
